module.exports = __webpack_public_path__ + "img/editor_qq.a5f0dfc8.png";